module.exports = __webpack_public_path__ + "img/health_advocate.e23d6480.svg";